export default __webpack_public_path__ + "images/aab900ac6a72870a20b1b711ca0d7a86-pride_mobile.webp";